const parseValidationErrors = (error) => {
	if (error && error.graphQLErrors && error.graphQLErrors.length > 0 && error.graphQLErrors[0].extensions) {
		const { invalidFields } = error.graphQLErrors[0].extensions;

		if (Array.isArray(invalidFields)) {
			const errors = invalidFields;
			return errors.reduce((acc, err) => ({ ...acc, [err.field]: err.message }), {});
		}
	}

	return {};
};

export default parseValidationErrors;
